module.exports = __webpack_public_path__ + "img/workplease.90deee14.png";